<template>
  <Collapse simple class="collapse-warpper" value="1">
    <Panel name="1" class="collapse-panel">
      <span class="panel-title">{{initdata.title}}</span>
      <div slot="content">
        <!-- 状态列表 -->
        <div class="state-list" @click="stateClick">
          <div
            class="state-item"
            v-for="(item,index) in stateList"
            :style="{color:getColor(item),backgroundColor:getBgColor(item),borderColor:item.stateColor}"
            :data-index="index"
            :key="item.stateCode"
          >{{item.value}}</div>
        </div>
      </div>
    </Panel>
  </Collapse>
</template>

<script>
export default {
  mounted() {},
  props: ["initdata", "filterListIndex"],
  data() {
    return {
      actived: false,
      code:''
    };
  },
  methods: {
    stateClick(e) {
      let index = e.target.dataset.index;
      /* 单选 */
      for (let item of this.stateList) {
        item.active = false;
      }
      
      this.stateList[index].active = !this.stateList[index].active;
      this.code = this.stateList[index].stateCode
      this.$emit("event", {
        fn: "authchange",
        params: {
          stateCode: this.code,
          filterListIndex: this.filterListIndex
        }
      });
    },
    // 获取文本的颜色
    getColor(el) {
      return el.active ? '#fff' : el.stateColor;
    },
    // 获取背景颜色
    getBgColor(el){
      return el.active ? el.stateColor : '#fff';
    },
    reset() {
      for (let item of this.stateList) {
        item.active = false;
      }
      this.code=''
      this.$emit("event", {
        fn: "reset",
      })
    }
  },
  computed: {
    stateList: function() {
      return this.initdata.stateList;
    }
  },
  watch:{
    initdata () {
      this.initdata.stateList.forEach(item => {
        if (item.stateCode === this.code) {
          item.active = true
        }
      })
    }
  },
  components: {}
};
</script>
<style scoped lang="less">
@import "./collapse.less";
.state-list {
  display: flex;
  align-items: center;
  // justify-content: space-around;
  flex-wrap: wrap;
}
.state-item {
  width: 62px;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  border: 1px solid transparent;
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>

